import { Spinner } from "react-bootstrap";
import { Redirect, useLocation } from "react-router-dom";
import { Container } from "components/Layout/Container";
import { PageLink } from "components/App/utils";
import { getGuestLinkParams, useGuestLogin } from "components/utils/useGuestLogin";

/**
 * Target of the guest access link from email. Exchanges the one-time auth code for a guest session on its own URL,
 * so the sign-in page is only shown when the link has expired.
 */
export function GuestLoginPage() {
    const location = useLocation();
    const { customerNumber, authCode } = getGuestLinkParams(location.pathname);
    const status = useGuestLogin(customerNumber, authCode);

    if (!customerNumber || !authCode || status === "expired") {
        // The sign-in page shows the "link expired" flow and lets the guest request a new link for the same page.
        return <Redirect to={{ pathname: PageLink.SignIn, state: { referrer: location.pathname + location.search } }} />;
    }

    return (
        <Container style={{ maxWidth: 480 }} className="mt-6 mb-6 text-center">
            <Spinner as="span" animation="border" role="status">
                <span className="visually-hidden">Signing in as a guest</span>
            </Spinner>
        </Container>
    );
}
